module.exports = __webpack_public_path__ + "img/p-taiwanpay.ed43aeed.svg";